import { gql } from '@apollo/client';
import { MediaQueries } from '@minecraft.shared-queries';

export const GET_CREATE_PROFILE_UPLOADED_PHOTO = gql`
  {
    createProfileUploadedPhoto @client {
      ...BaseMediaWithThumbnail
    }
  }
  ${MediaQueries.baseMediaWithThumbnailFragment}
`;
